module.exports = __webpack_public_path__ + "static/media/Other-Vehicle-Icon.bde51420.svg";